import type { ClientPortfolioToolReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

export const formatFundValue = (
	toolsSummary: ClientPortfolioToolReportingSummaryResponseDTO[] | undefined,
	toolId: number,
	t: ReturnType<typeof useResource>["t"],
): string => {
	const summary = toolsSummary?.find((s) => s.toolId === toolId);
	if (!summary) {
		return "";
	}
	const currency = t(
		Resources.PortfolioDetail.SharedLabels.Currency[summary.currency],
	);
	return moneyFormatter(summary.totalValue, currency, undefined, 0);
};
